
import Select from 'react-select';
import DropDownStyles, { selectMenuPortalProps } from './dropdownStyles';

const FishTypesSelection = ({ fishTypes, selectedFishTypes, onChange, error }) => {
    // Map fish types to react-select options
    const fishTypeOptions = fishTypes.map(fish => ({
        value: fish.FishTypeID,
        label: fish.FishTypeName,
    }));

    return (
        <div className="form-floating mb-15px">
            <Select
                isMulti
                options={fishTypeOptions}
                value={selectedFishTypes}
                styles={DropDownStyles}
                {...selectMenuPortalProps}
                onChange={onChange}
                className={error ? 'is-invalid' : ''}
                placeholder="Select Fish Types"
            />
            {error && <div className="invalid-feedback d-block">{error}</div>}
        </div>
    );
};

export default FishTypesSelection;